import React from 'react';
import FB from './fb/fb';

function App() {
  return (
     <FB/>
  );
}

export default App;
